import { Tag, type TableColumnsType } from 'antd';
import { CatalogueRowActions } from '../../../../../shared/components/CatalogueRowActions';
import type { JobReasonCode } from '../../../reference-data.api';

interface BuildReasonCodeColumnsArgs {
  onEdit: (row: JobReasonCode) => void;
  onDeactivate: (row: JobReasonCode) => Promise<void>;
  onReactivate: (row: JobReasonCode) => Promise<void>;
}

export function buildReasonCodeColumns({ onEdit, onDeactivate, onReactivate }: BuildReasonCodeColumnsArgs): TableColumnsType<JobReasonCode> {
  return [
    { title: 'Code', dataIndex: 'code', key: 'code', render: (code: string) => <span className="font-mono text-xs">{code}</span> },
    { title: 'Name', dataIndex: 'name', key: 'name' },
    {
      title: 'Applies to',
      key: 'appliesTo',
      render: (_, row) => (
        <span className="flex gap-1">
          {row.appliesToHold && <Tag>Hold</Tag>}
          {row.appliesToCancel && <Tag>Cancel</Tag>}
        </span>
      ),
    },
    {
      title: 'Status',
      dataIndex: 'isActive',
      key: 'isActive',
      render: (isActive: boolean) => <Tag color={isActive ? 'success' : 'default'}>{isActive ? 'Active' : 'Inactive'}</Tag>,
    },
    {
      title: '',
      key: 'actions',
      render: (_, row) => <CatalogueRowActions row={row} onEdit={onEdit} onDeactivate={onDeactivate} onReactivate={onReactivate} />,
    },
  ];
}
